import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '~src/httpClient/RestApiService';

import { ICreateUpdateScimConfigurationRequest,ICreateUpdateScimConfigurationResponse, IScimConfiguration } from '../../services/ScimConfigurationsService';

export function updateScimConfigurationRequestConfig(scimConfig: IScimConfiguration): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.26',
    httpMethod: 'PATCH',
    endpoint: `scimConfigurations/${scimConfig.id}`,
    serverWideRequest: false
  };
}

export function callUpdateScimConfigurationRequest(scimConfig: IScimConfiguration): Promise<ICreateUpdateScimConfigurationResponse> {
  return makeJsonRestApiRequest<ICreateUpdateScimConfigurationRequest, ICreateUpdateScimConfigurationResponse>({
    config: updateScimConfigurationRequestConfig(scimConfig),
    request: {
        scimConfiguration: {
        ...(scimConfig.name && { name: scimConfig.name }) ,
        ...(scimConfig.idpConfigurationId && {idpConfigurationId: scimConfig.idpConfigurationId}),
        ...(scimConfig.type && {authType: scimConfig.type})
      }
    },
  });
}
